import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'learn.honorCode.name': {
    id: 'learn.honorCode.name',
    defaultMessage: 'Honor Code',
    description: 'Honor code name.',
  },
  'learn.honorCode.cancel': {
    id: 'learn.honorCode.cancel',
    defaultMessage: 'Cancel',
    description: '"Cancel" button.',
  },
  'learn.honorCode.agree': {
    id: 'learn.honorCode.agree',
    defaultMessage: 'I agree',
    description: '"I agree" button.',
  },
});

export default messages;
